<template>
  <div class="divTd">
    <p class="divTdTtl">
      <b v-if="p_editor.must">*</b>
      {{ p_editor.label }}：
    </p>
    <p v-if="p_editor.readonly" class="divTdEdit">
      <input :value="p_key" class="bdRead" readonly>
    </p>
    <p v-if="!p_editor.readonly" class="divTdEdit">
      <input v-if="p_editor.vvtype==='5'" v-model="p_key" type="hidden">
      <input v-if="p_editor.vvtype==='5'" v-model="editValue" type="text" class="bdBlue" @click="pick">

      <input v-if="p_editor.vvtype===undefined" v-model="editValue" class="bdBlue" @change="vChg">
      <input v-if="p_editor.vvtype==='1'" v-model="editValue" type="number" class="bdBlue" @change="vChg">
      <input v-if="p_editor.vvtype==='3'" v-model="editValue" type="date" class="bdBlue" @change="vChg">
      <input v-if="p_editor.vvtype==='4'" v-model="editValue" type="datetime" class="bdBlue" @change="vChg">
      <input v-if="p_editor.vvtype==='6'" v-model="editValue" type="text" class="bdBlue" @change="vChg">
    </p>
  </div>
</template>
<script type="text/javascript">
export default{
  name: 'Editor',
  props: {
    p_editor: {
      type: Object,
      default: () => {
        return {}
      }
    },
    p_key: {
      type: Number,
      default: 0
    }, // fid字段,fidcust...
    p_value: {
      type: String,
      default: ''
    },
    a_pick: {
      type: Function,
      default: null
    },
    a_chg: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      editType: 'text',
      editValue: ''
    }
  },
  watch: {
    p_value: {
      handler(newV, oldV) {
        this.editValue = newV
      },
      immediate: true// deep: true
    }
  },
  created: function() {
    this.editValue = this.p_value
    if (this.p_editor.vvtype === '1') this.editType = 'number'
    if (this.p_editor.vvtype === '3') this.editType = 'date'
    if (this.p_editor.vvtype === '4') this.editType = 'datetime'
    if (this.p_editor.vvtype === '5') this.editType = 'text'
  },
  methods: {
    pick() {
      this.a_pick(this.p_editor, -1)
    },
    vChg() {
      console.log('05_editor.vChg', this.p_editor)
      this.a_chg(this.p_editor.value, this.editValue)
    }
  }

}
</script>
<style>/**scoped */
.divTd{
  float: left;
  display: flex;
  flex-direction: row;
  width: 320px;
  margin-bottom: 5px;
}
.divTdTtl{
  width:125px;
  text-align: right;
  padding-right: 5px;
}
.divTdTtl b{
  color:red
}
.divTdEdit{
  width:185px;
  padding-right: 5px;
}
.divTdEdit input{
  width:185px;
  padding: 0;
}
.bdBlue{
  border: 1px solid #acc;
}
</style>



// WEBPACK FOOTER //
// src/comps/c3_tools/05_editor.vue